import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersMeetingNotesIndexRequestType,
  ApiMembersMeetingNotesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersMeetingNotesIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersMeetingNotesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersMeetingNotesIndexResponseType>(
      "/api/members/meeting_notes",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersMeetingNotesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersMeetingNotesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersMeetingNotesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersMeetingNotesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
